import React from 'react';
import { Link } from 'react-router-dom';

const OurTeamOne = () => {
    return(
    <>
    {/*Team Section*/}
    <section className="section-padding-one teams-section section-padding-all">
        <div className="default-container">
          <div className="row clearfix mt-3">
            <div className="col-lg-3 mb-4">
              <div className="team-box-all text-center">
                <div className="team-img">
                  <img src="images/team/tm-01-460x460.png" alt="" className="img-fluid mx-auto d-block" />
                </div>
                <div className="mt-3">
                  <h6 className="mb-0 font-weight-bold">Jeffery Newman</h6>
                  <p className="text-muted team-work">CEO</p>
                </div>
                <div className="team_social">
                  <ul className="list-inline mb-0 text-center">
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-pinterest" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-instagram" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="team-box-all text-center">
                <div className="team-img">
                  <img src="images/team/tm-02-460x460.png" alt="" className="img-fluid mx-auto d-block" />
                </div>
                <div className="mt-3">
                  <h6 className="mb-0 font-weight-bold">Christopher Mayo</h6>
                  <p className="text-muted team-work">Founder</p>
                </div>
                <div className="team_social">
                  <ul className="list-inline mb-0 text-center">
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-pinterest" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-instagram" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="team-box-all text-center">
                <div className="team-img">
                  <img src="images/team/tm-03-460x460.png" alt="" className="img-fluid mx-auto d-block" />
                </div>
                <div className="mt-3">
                  <h6 className="mb-0 font-weight-bold">Douglass Foster</h6>
                  <p className="text-muted team-work">Co-Founder</p>
                </div>
                <div className="team_social">
                  <ul className="list-inline mb-0 text-center">
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-pinterest" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-instagram" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="team-box-all text-center">
                <div className="team-img">
                  <img src="images/team/tm-04-460x460.png" alt="" className="img-fluid mx-auto d-block" />
                </div>
                <div className="mt-3">
                  <h6 className="mb-0 font-weight-bold">Ismael Oliver</h6>
                  <p className="text-muted team-work">Sr. Developers</p>
                </div>
                <div className="team_social">
                  <ul className="list-inline mb-0 text-center">
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-pinterest" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-instagram" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="team-box-all text-center">
                <div className="team-img">
                  <img src="images/team/tm-01-460x460.png" alt="" className="img-fluid mx-auto d-block" />
                </div>
                <div className="mt-3">
                  <h6 className="mb-0 font-weight-bold">Ismael Oliver</h6>
                  <p className="text-muted team-work">Sr. Developers</p>
                </div>
                <div className="team_social">
                  <ul className="list-inline mb-0 text-center">
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-pinterest" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-instagram" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="team-box-all text-center">
                <div className="team-img">
                  <img src="images/team/tm-02-460x460.png" alt="" className="img-fluid mx-auto d-block" />
                </div>
                <div className="mt-3">
                  <h6 className="mb-0 font-weight-bold">Ismael Oliver</h6>
                  <p className="text-muted team-work">Sr. Developers</p>
                </div>
                <div className="team_social">
                  <ul className="list-inline mb-0 text-center">
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-pinterest" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-instagram" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="team-box-all text-center">
                <div className="team-img">
                  <img src="images/team/tm-03-460x460.png" alt="" className="img-fluid mx-auto d-block" />
                </div>
                <div className="mt-3">
                  <h6 className="mb-0 font-weight-bold">Ismael Oliver</h6>
                  <p className="text-muted team-work">Sr. Developers</p>
                </div>
                <div className="team_social">
                  <ul className="list-inline mb-0 text-center">
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-pinterest" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-instagram" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="team-box-all text-center">
                <div className="team-img">
                  <img src="images/team/tm-04-460x460.png" alt="" className="img-fluid mx-auto d-block" />
                </div>
                <div className="mt-3">
                  <h6 className="mb-0 font-weight-bold">Ismael Oliver</h6>
                  <p className="text-muted team-work">Sr. Developers</p>
                </div>
                <div className="team_social">
                  <ul className="list-inline mb-0 text-center">
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                    <li className="list-inline-item"><Link to="#" className><i className="fa fa-pinterest" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-instagram" /></Link></li>
                    <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>
    {/*End Team Section*/}
    </>
    )
}

export default OurTeamOne;